import React from "react";
import { cn } from "@/lib/utils";
import { PackageSearch } from "lucide-react";

export function EmptyState({ icon: Icon = PackageSearch, title, description, action, className }) {
  return (
    <div className={cn("rounded-2xl border border-border bg-card py-16 px-6 text-center", className)}>
      <div className="mx-auto w-12 h-12 rounded-full bg-accent text-primary flex items-center justify-center mb-3">
        <Icon className="w-5 h-5" />
      </div>
      <div className="font-heading text-base font-semibold">{title}</div>
      {description && <div className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function Skeleton({ className = "h-4 w-full" }) {
  return <div className={cn("rounded-md bg-muted/60 animate-pulse", className)} />;
}

export function KpiCard({ label, value, icon: Icon, hint, accent }) {
  return (
    <div className="rounded-2xl border border-border bg-card p-4 sm:p-5 shadow-sm" data-testid={`kpi-card-${String(label).toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between">
        <div className="text-xs text-muted-foreground font-medium">{label}</div>
        {Icon && (
          <div className={cn("w-8 h-8 rounded-lg flex items-center justify-center", accent || "bg-primary/10 text-primary")}>
            <Icon className="w-4 h-4" />
          </div>
        )}
      </div>
      <div className="mt-2 text-2xl font-semibold tabular-nums font-heading">{value}</div>
      {hint && <div className="text-[11px] text-muted-foreground mt-1">{hint}</div>}
    </div>
  );
}
